export const COOKIE_KEY = "state";

export interface CookieState {
  puzzleIndex: number;
  currentGuess: string;
  time: number | undefined;
}
